import React, { Component } from 'react'
import styled from 'styled-components'
import { compose } from 'react-apollo'
import { Link, withRouter } from 'react-router-dom'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { connect } from 'react-redux'
import easing from 'ui/styles/easing'

import withNav from 'containers/withNav'

import Burger from './Burger'
import Menu from './Menu'
import Search from './Search/'
import SearchButton from './SearchButton'
import Overlay from './Overlay'

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100vw;
`

const NavBar = styled.div`
  padding: 12px 0;
  color: white;
  position: absolute;
  width: 100%;
  background-color: ${props => props.isScrolled || props.searchActive ? props.theme.colors[props.colorScheme].light : 'none'};
  transition: background-color 0.3s ${easing.easeOutCubic};
  z-index: 20;

  ${media.lg`
    padding: 20px 0;
  `}
`

const Logo = styled(Col)`
  text-align: center;
  font-size: 22px;
  font-family: 'Hill';
  letter-spacing: 0.05em;
  position: relative;
  z-index: 1;
  font-weight: 600;

  a {
    color: inherit;
  }

  ${media.xs`
    font-size: 20px;
    margin-top: 4px;
  `}
`

const SearchButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

class Navigation extends Component {
  constructor(props) {
    super(props)

    this.toggleNav = this.toggleNav.bind(this)
  }
  
  state = {
    navActive: false,
    searchActive: false,
    subnavActive: false,
    isScrolled: false,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.checkScrollPosition)
    this.checkScrollPosition()
  }

  checkScrollPosition = () => {
    const { isScrolled } = this.state
    const scrollPosition = document.scrollingElement ? document.scrollingElement.scrollTop : 0

    if(scrollPosition > 50 && !isScrolled) {
      this.setState({ isScrolled: true })
    } else if(scrollPosition <= 50 && isScrolled) {
      this.setState({ isScrolled: false })
    }
  }

  toggleNav() {
    const { navActive } = this.state

    if(navActive) {
      document.getElementById('root').classList.remove('no-scroll')
    } else {
      document.getElementById('root').classList.add('no-scroll')
    }
    
    this.setState({
      navActive: !navActive,
      searchActive: false
    })
  }
  
  toggleSearch() {
    const { searchActive } = this.state
        
    if(searchActive) {
      document.getElementById('root').classList.remove('no-scroll')
    } else {
      document.getElementById('root').classList.add('no-scroll')
    }

    this.setState({
      searchActive: !searchActive,
      navActive: false
    })
  }

  render() {
    const {
      navActive,
      searchActive,
      isScrolled,
    } = this.state

    const {
      theme
    } = this.props

    return (
      <Wrapper>
        <NavBar
          colorScheme={theme}
          isScrolled={isScrolled}
          navActive={navActive}
          searchActive={searchActive}
        >
          <Container fluid>
            <Row alignItems="center">
              <Col col={2}>
                <div onClick={() => this.toggleNav()}>
                  <Burger active={navActive} />
                </div>
              </Col>
              <Logo col={8}>
                <Link to="/">
                  <span>Vesterdal Efterskole</span>
                </Link>
              </Logo>
              <Col col={2}>
                <SearchButtonContainer onClick={() => this.toggleSearch()}>
                  <SearchButton active={searchActive} />
                </SearchButtonContainer>
              </Col>
            </Row>
          </Container>
        </NavBar>

        <Menu
          active={navActive}
          colorScheme={theme}
          toggleNav={this.toggleNav}
        />

        <Search
          active={searchActive}
          colorScheme={theme}
          toggleNav={this.toggleSearch}
        />

        <Overlay
          active={navActive}
          toggleNav={this.toggleNav}
        />

      </Wrapper>
    );
  }
}

export default compose(
  withRouter,
  withNav('MAIN_NAV', 'mainNav'),
  connect(state => ({ breakpoint: state.media.breakpoint, theme: state.theme }))
)(Navigation)



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/index.js